var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pdf-app"}},[_c('PSPDFKitContainer',{attrs:{"pdfFile":_vm.pdfFile},on:{"loaded":_vm.handleLoaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }